import React, { useState, useContext } from "react";
import { AuthContext } from "../../AuthContext";
import StatsOverview from "./StatsOverview";
import RegStats from "./RegStats";
import UserSearch from "./UserSearch";
import UsersPayments from "./UsersPayments"; // Импортируем модуль финансов
import s from "../../admin_styles/AdminDashboard.module.css";
import TagSwitcher from "../tags/TagSwitcher";
import DumpManager from "../dumps/DumpManager"
import EmailCenterTab from "./EmailCenterTab";
import ExternalApiKeysManager from "./ExternalApiKeysManager";
import MailImagesManager from "./MailImagesManager";
import News from "./News";

export default function AdminDashboard() {
  const { role } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState("search"); // "search" или "payments"

  return (
    <div className={s.all_dashboard_div}>
      <div className={s.count_stats_div}>
        <StatsOverview />
        <RegStats />
      </div>

      <div className={s.tabs_buttons_div}>
        <button
          className={activeTab === "search" ? s.activeTabButton : s.tabButton}
          onClick={() => setActiveTab("search")}
        >
          Поиск пользователей
        </button>
        <button
          className={activeTab === "payments" ? s.activeTabButton : s.tabButton}
          onClick={() => setActiveTab("payments")}
        >
          Финансы
        </button>
        <button
          className={activeTab === "tags" ? s.activeTabButton : s.tabButton}
          onClick={() => setActiveTab("tags")}
        >
          Тэги
        </button>
        {role === "superadmin" && (
        <button
          className={activeTab === "dumps" ? s.activeTabButton : s.tabButton}
          onClick={() => setActiveTab("dumps")}
        >
          Архив БД
        </button>
        )}
        <button
          className={activeTab === "email-center" ? s.activeTabButton : s.tabButton}
          onClick={() => setActiveTab("email-center")}
        >
          Email центр
        </button>
        <button
          className={activeTab === "mail-images" ? s.activeTabButton : s.tabButton}
          onClick={() => setActiveTab("mail-images")}
        >
          Фото для писем
        </button>
        {role === "superadmin" && (
          <button
            className={activeTab === "api-keys" ? s.activeTabButton : s.tabButton}
            onClick={() => setActiveTab("api-keys")}
          >
            API ключи
          </button>
        )}
        {role === "superadmin" && (
          <button
            className={activeTab === "news" ? s.activeTabButton : s.tabButton}
            onClick={() => setActiveTab("news")}
          >
            Новости
          </button>
        )}
      </div>

      <div className={s.usersearch_in_dashboadr_div}>
        {activeTab === "search" && <UserSearch />}
        {activeTab === "payments" && <UsersPayments />}
        {activeTab === "tags" && <TagSwitcher />}
        {activeTab === "dumps" && role === "superadmin" && <DumpManager />}
        {activeTab === "email-center" && <EmailCenterTab />}
        {activeTab === "mail-images" && <MailImagesManager />}
        {activeTab === "api-keys" && role === "superadmin" && <ExternalApiKeysManager />}
        {activeTab === "news" && role === "superadmin" && <News />}
      </div>
    </div>
  );
}
